//
//
//
//
//
//
//
//

import { CMSService } from '~/services/storyBlok/cmsService';

export default {
  name: 'Accessories',
  async asyncData({ $storyapi, error }) {
    const storyBlok = new CMSService({ cmsService: $storyapi });
    let storyResp = [];

    await storyBlok.get('shop/accessories', { resolve_relations: 'AccessoryProducts.products' })
      .then((resp) => {
        storyResp = resp?.data?.story?.content;
      })
      .catch((err) => {
        error({ message: err?.message });
      });
    return { storyResp };
  },
};
